import { getCurrentDateTime, getDateTimeFrom } from '../../helpers/datetime'

export const ALERT_LIST_CONTAINER_SCROLL_ID = 'ALERT_LIST_CONTAINER_SCROLL_ID'

export const READ_STATUS = {
  READ: {
    key: 'READ',
    value: true,
    name: 'alerts.READ',
  },
  UNREAD: {
    key: 'UNREAD',
    value: false,
    name: 'alerts.UNREAD',
  },
}

export const TIME_PERIOD = {
  ALL: {
    key: 'ALL',
    label: 'alerts.timePeriod.ALL',
    startDate: getDateTimeFrom(new Date(), -1, 'years'),
    endDate: getCurrentDateTime(),
  },
  PAST_30_DAYS: {
    key: 'PAST_30_DAYS',
    label: 'alerts.timePeriod.PAST_30_DAYS',
    startDate: getDateTimeFrom(new Date(), -30, 'days'),
    endDate: getCurrentDateTime(),
  },
  PAST_90_DAYS: {
    key: 'PAST_90_DAYS',
    label: 'alerts.timePeriod.PAST_90_DAYS',
    startDate: getDateTimeFrom(new Date(), -90, 'days'),
    endDate: getCurrentDateTime(),
  },
  PAST_6_MONTHS: {
    key: 'PAST_6_MONTHS',
    label: 'alerts.timePeriod.PAST_6_MONTHS',
    startDate: getDateTimeFrom(new Date(), -6, 'months'),
    endDate: getCurrentDateTime(),
  },
  CUSTOM: {
    key: 'CUSTOM',
    label: 'alerts.timePeriod.CUSTOM',
  },
}

export const SEARCH_OPTIONS = {
  COMPANY: {
    key: 'COMPANY',
    value: 'COMPANY',
    label: 'alerts.COMPANY',
    isI18n: true,
  },
  INDUSTRY: {
    key: 'INDUSTRY',
    value: 'INDUSTRY',
    label: 'alerts.INDUSTRY',
    isI18n: true,
  },
}

export const TABLE_COL = {
  CHECKBOX: 'CHECKBOX',
  SUBJECT: 'subjectName',
  SUBJECT_TYPE: 'subjectType',
  TYPE_DESCRIPTION: 'alertDesc',
  DATE: 'createDate',
  TRIGGER: 'profilePortfoliosList',
  DELETE: 'DELETE',
}

export const PAGE_SIZE_OPTIONS = [
  { label: 20, value: 20 },
  { label: 50, value: 50 },
  { label: 100, value: 100 },
  { label: 500, value: 500 },
]
